// import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa6";
import * as Icon from 'react-bootstrap-icons';

import { startLogout } from '../../../../redux/slices/auth';

import styles from './Navbar.module.css';

export const Navbar = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { membresia } = useSelector(state => state.auth);

    const handleLogout = () => {
        dispatch(startLogout());
        navigate("/");
    }

    return (
        <>
            <nav className={"navbar navbar-expand-xxl fixed-top bg-body-tertiary p-3 " + styles.navbar}>
                <div className={"container " + styles.navbarContainerFluid}>
                    <Link to="/" className="navbar-brand">
                        <div className={styles.navbarLogo} />
                    </Link>
                    <button className={"navbar-toggler " + styles.navbarToggler} type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <FaBars />
                    </button>
                    <div className={"collapse navbar-collapse " + styles.navbarColapse} id="navbarToggler">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className={"nav-item " + styles.navTextItem}><div className={styles.logoutIconContainer}>
                                { membresia } <Icon.BoxArrowRight className={styles.logoutIcon} onClick={handleLogout} />
                            </div></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}
